/** Format an already-percent-valued metric for customer-facing presentation. */
export function formatPercentage(value, { decimals = 1, unavailable = "—" } = {}) {
  if (value === null || value === undefined || value === "") return unavailable;
  if (typeof value === "string" && value.trim() === "") return unavailable;

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return unavailable;

  return `${parsed.toFixed(decimals)}%`;
}
